import { Injector, Pipe, PipeTransform } from '@angular/core';
import { ColumnFormatService } from './column-format.service';

@Pipe({
    name: 'columnformatter'
})
export class ColumnFormatterPipe implements PipeTransform {

    constructor( private injector: Injector, private colmunFormatSer: ColumnFormatService ) {}

    transform(value: any, col: { field: string, formatter?: any }, ...args: any[]): any {
        const data = args[0];
        if(col) {
            if(col.formatter) {
                return this.colmunFormatSer.format(value, data, col.formatter);
            }

            return value;
        }

        return value;
    }
}